import {ProductOverviewComponent} from './product-overview.component';
import {ProductFormComponent} from './product-form.component';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'management.product',
    component: ProductOverviewComponent,
    future: true,
    data: {
      pageTitle: 'states.product.pageTitle',
      scopes: ['management:read']
    }
  },
  {
    name: 'management.product.add',
    component: ProductFormComponent,
    future: true,
    data: {
      pageTitle: 'states.product.add.pageTitle',
      scopes: ['management:create']
    }
  },
  {
    name: 'management.product.edit',
    component: ProductFormComponent,
    future: true,
    data: {
      pageTitle: 'states.product.edit.pageTitle',
      scopes: ['management:update']
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class ProductRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/product/product.routes.ts